<template>
  <div class="container text-center discover-section">
    <loading v-model:active="isLoading" :is-full-page="true" />
    <div class="waitingBlock bgColor" v-if="!isLoading">
      <div
        class="row no-gutters align-item-center justify-content-center"
        v-if="waitData.length > 2"
      >
        <div class="col-md-3">
          <div class="card">
            <div class="card-body mb-0 pb-0">
              <vue-load-image>
                <template v-slot:image>
                  <img
                    class="card-img-top"
                    :src="getImgUrl(waitData[0].data.img)"
                    alt=""
                  />
                </template>
                <template v-slot:preloader>
                  <img
                    class="card-img-top px-3 pt-3 pb-0"
                    src="/lostsailor/images/loader.gif"
                  />
                </template>
                <template v-slot:error>Image load fails</template>
              </vue-load-image>
            </div>
          </div>
          <h4 class="text-uppercase fontBold mb-0 mt-1">Captain</h4>
        </div>

        <div class="col-md-3">
          <div class="img">
            <img src="images/ship-wheel.png" alt="" />
          </div>
        </div>
        <div class="col-md-3">
          <div class="card">
            <div class="card-body p-0">
              <vue-load-image class="h-100">
                <template v-slot:image>
                  <div class="card-img">
                    <img
                      class="card-img-top px-1"
                      :src="getImgUrl(waitData[1].data.img)"
                      alt=""
                    />
                  </div>
                </template>
                <template v-slot:preloader>
                  <img class="card-img-top" src="/lostsailor/images/loader.gif" />
                </template>
                <template v-slot:error>Image load fails</template>
              </vue-load-image>
            </div>
          </div>
          <h4 class="text-uppercase fontBold mt-1 mb-0">Ship</h4>
        </div>
      </div>

      <div class="justify-content-center mb-3 d-flex ju w-70 mx-auto">
        <button class="btn btn-outline font-weight-bold">Supplies</button>
      </div>
      <div class="card-container">
        <div class="card-1">
          <div class="card-body h-100 justify-content-between">
            <h1>Food</h1>
            <h1>{{ info.food.length }}</h1>
          </div>
        </div>
        <div class="card-1">
          <div class="card-body h-100 justify-content-between">
            <vue-load-image>
              <template v-slot:image>
                <img
                  class="card-img-top"
                  :src="getImgUrl(waitData[2].data.img)"
                  alt=""
                />
              </template>
              <template v-slot:preloader>
                <img class="card-img-top" src="/lostsailor/images/loader.gif" />
              </template>
              <template v-slot:error>Image load fails</template>
            </vue-load-image>
          </div>
        </div>
      </div>
      <div class="text-center">
        <h1
          class="text-uppercase fontBold mb-0"
          v-if="counter == 'Invalid date' || gameOver"
        >
          Game completed claim reward
        </h1>
        <h3>Attack location : {{ info.location }}</h3>
        <h1 class="text-uppercase fontBold mb-0" v-if="!gameOver">
          Duration: {{ parseInt(info.duration) }} Hours,
          {{ Number((info.duration - parseInt(info.duration)) * 60).toFixed() }}
          mins
        </h1>
        <h5 class="text-uppercase fontBold mb-0" v-if="!gameOver">Time left</h5>
        <h1 v-if="gameOver" class="text-success">
          {{ parseFloat(winningToken).toFixed(2) }} DOUB
        </h1>
        <br />
        <h2
          v-if="counter == 'Invalid date' || gameOver"
          class="text-uppercase fontBold"
        >
          <div class="select-btn">
            <a href="JavaScript:void(0)" class="btn" @click.prevent="claim()">
              <span class="d-block text-black p-0 m-0"></span>
              Claim
            </a>
          </div>
        </h2>
        <h2
          v-if="!gameOver"
          class="text-uppercase fontBold"
          :class="{ closetime: hoursLeft < 0.1 }"
        >
          {{ counter }}
        </h2>
        <div v-if="!gameOver">
          <a href="JavaScript:void(0)" @click.prevent="reset()">
            <span class="d-block text-black p-0 m-0"></span>
            Reset Attack
          </a>
        </div>
        <h2 v-if="counter == 'Invalid date'">Loading...</h2>
        <p v-if="counter == 'Invalid date'" class="help-text">
          if loading takes longer then 5 sec refresh the page.
        </p>
        <a href="/dashboard" class="d-inline"
          ><i class="fal fa-angle-left"></i
        ></a>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "../services";
import moment from "moment";
import { useToast } from "vue-toastification";
const toast = useToast();
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { mapGetters } from "vuex";
import VueLoadImage from "vue-load-image";
export default {
  name: "Waiting",
  components: {
    Loading,
    "vue-load-image": VueLoadImage,
  },
  computed: {
    ...mapGetters(["waitData"]),
  },
  data() {
    return {
      info: null,
      isLoading: true,
      counter: "0",
      gameOver: false,
      winningToken: 0,
      hoursLeft: 0,
      timeLeft: 0,
      duration: 0,
      expiredDate: "",
      endTime: "",
      hour: "",
      winningTokenWithoutCom: 0,
      t: true,
    };
  },
  mounted() {
    this.isLoading = true;
    ApiService.getAttack((res) => {
      setTimeout(() => {
        this.isLoading = false;
      }, 1000);
      if (res !== false) {
        this.$store.dispatch("stakeNfts", res);
        this.info = res;
        this.winningToken = parseFloat(res.reward.replace(/DOUB/g, ""));
        this.startTime = res.attack_time;
        this.endTime = res.end_time;
        this.expiredDate = res.expiredDate;
        this.hoursLeft = res.hoursLeft;
        this.gameOver = res.gameOver;
        this.duration = res.duration;
        this.winningTokenWithoutCom = ApiService.niceFloat(
          Number((20 / Number(this.winningToken)) * 100).toFixed(8)
        );
        if (!this.gameOver && !this.countDown) {
          this.countDown = setInterval(() => {
            if (this.counter == "0:00:00" || this.counter.indexOf("-") !== -1) {
              this.counter = 0;
              this.title = "Battle Ended";
              this.gameOver = true;
              clearInterval(this.countDown);
            }
            let currentUtc = moment
              .utc(new Date())
              .format("YYYY-MM-DDTHH:mm:ss.SSSS");
            if (this.hoursLeft < 1) {
              this.counter = moment
                .utc(moment(this.endTime).diff(currentUtc))
                .format("mm:ss");
            } else {
              this.hour = moment
                .duration(moment(this.expiredDate).diff(currentUtc))
                .asHours();
              this.counter =
                Math.trunc(this.hour) +
                ":" +
                moment
                  .utc(moment(this.endTime).diff(moment(currentUtc)))
                  .format("mm:ss");
            }
          }, 1000);
        } else {
          clearInterval(this.countDown);
        }
      } else {
        this.$router.push("dashboard");
      }
    });
  },
  methods: {
    getImgUrl(hash) {
      return ApiService.getImgUrl(hash);
    },
    async claim() {
      if (this.gameOver || this.counter == 0) {
        await ApiService.claim(
          (res) => {
            if (res.processed) {
              localStorage.removeItem("location");
              let token = Number(this.winningToken).toFixed(8);
              this.$store.commit("updateBalance", token);
              toast.success("Token claimed successfully");
              setTimeout(() => {
                this.$router.push("/dashboard");
              }, 3000);
            }
          },
          (error) => {
            this.error = ApiService.errorFormat(error);
            toast.error(this.error);
          }
        );
      } else {
        this.error = "Game not over yet.";
        toast.error(this.error);
      }
    },
    async reset() {
      await ApiService.resetAttack(
        (res) => {
          if (res.processed) {
            localStorage.removeItem("location");
            toast.success("Attack has been reset successfully");
            this.$router.push("/dashboard");
          }
        },
        (error) => {
          this.error = ApiService.errorFormat(error);
          toast.error(this.error);
        }
      );
    },
  },
};
</script>
<style scoped>
.select-btn {
  text-align: center;
}

.card {
  background: transparent;
  margin: auto;
}
.card-img {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 3px;
}
.btn {
  color: #fff;
}
.btn:hover {
  color: #fff !important;
}
</style>